






















import { defineComponent, ref } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// Composables
import useFacets from '@/composables/search/useFacets'

// Common
import { hiddenFacets } from '@/common/static/facets'
import { NESTED_FACET_NAMES } from '@/common/static/search'

export default defineComponent({
  setup() {
    const { existingFacetIndex } = useFacets()
    const searchStore = useSearchStore()
    const { getResults: results } = storeToRefs(searchStore)
    const showMoreFilterButton = ref(false)

    const clickOnMoreFilters = () => {
      searchStore.setShowAllFacets(true)
      showMoreFilterButton.value = !showMoreFilterButton.value
    }

    const clickOnLessFilters = () => {
      searchStore.setShowAllFacets(false)
      showMoreFilterButton.value = !showMoreFilterButton.value
    }

    const showButton = () => {
      const facetsHidden = []
      // go over each hidden facet
      // if the facet is already selected
      // or the facet does not have data inside
      // delete if from the array
      hiddenFacets.forEach((facetName: string) => {
        if (facetName === NESTED_FACET_NAMES.other.key) {
          facetsHidden.push(facetName)
        }

        // if it is not selected
        if (
          existingFacetIndex(facetName) === -1 &&
          results.value.facets !== undefined &&
          results.value.facets[facetName] !== undefined &&
          results.value.facets[facetName][0].data!.length > 1
        ) {
          facetsHidden.push(facetName)
        }
      })
      return facetsHidden.length > 0
    }

    return {
      clickOnMoreFilters,
      clickOnLessFilters,
      showMoreFilterButton,
      searchStore,
      showButton,
      hiddenFacets,
    }
  },
})
